class VideoBanner extends HTMLElement {
  constructor() {
    super();

    var _this = this;
    
    this.desktopVideo = this.querySelector('[data-desktop-element]');
    this.mobileVideo = this.querySelector('[data-mobile-element]');
    this.playpauseButton = this.querySelector('.pb-play-pause-button');

    this.playpauseButton.addEventListener('click', this.playpauseManager.bind(this));

    window.addEventListener('resize', this.resize.bind(this));
    window.addEventListener('load', this.resize.bind(this));
  }

  resize() {
    var isPhone = window.matchMedia('screen and (max-width: 641px)').matches;
    let icon = this.playpauseButton.querySelector('svg use');
    if (isPhone) {
      this.mobileVideo.play();
      this.desktopVideo.pause(); 
      icon.setAttribute("xlink:href", "#sprite-controls-pause"); 
      this.playpauseButton.setAttribute('aria-pressed', false);

    } else {
      this.desktopVideo.play(); 
      this.mobileVideo.pause(); 
      icon.setAttribute("xlink:href", "#sprite-controls-pause"); 
      this.playpauseButton.setAttribute('aria-pressed', false);
    }
  }

  playpauseManager(){
    let icon = this.playpauseButton.querySelector('svg use');
    var isPhone = window.matchMedia('screen and (max-width: 641px)').matches;
    
    if (isPhone) {
      if (!this.desktopVideo.paused) {
        this.desktopVideo.pause();
        this.playpauseButton.setAttribute('aria-pressed', false);
      }
      
      if (this.mobileVideo.paused) {
        this.mobileVideo.play(); 
        icon.setAttribute("xlink:href", "#sprite-controls-pause"); 
        this.playpauseButton.setAttribute('aria-pressed', false);
      } else { 
        this.mobileVideo.pause();
        icon.setAttribute("xlink:href", "#sprite-controls-play-filled"); 
        this.playpauseButton.setAttribute('aria-pressed', true);
      }
    } else {
      if (!this.mobileVideo.paused) {
        this.mobileVideo.pause();
        this.playpauseButton.setAttribute('aria-pressed', false);
      }
      
      if (this.desktopVideo.paused) {
        this.desktopVideo.play(); 
        icon.setAttribute("xlink:href", "#sprite-controls-pause"); 
        this.playpauseButton.setAttribute('aria-pressed', false);
      } else { 
        this.desktopVideo.pause();
        icon.setAttribute("xlink:href", "#sprite-controls-play-filled"); 
        this.playpauseButton.setAttribute('aria-pressed', true);
      }
    }
  }
}
customElements.define('video-banner', VideoBanner);